/**
 * Payment methods that confirm after the order was sent (Adyen BLIK).
 *
 * Markup contract, inside the order form:
 *   <div x-data="delayedPayment">
 *     <div x-show="status" role="status">
 *       <strong x-text="status?.title"></strong>
 *       <p x-text="status?.description"></p>
 *
 * The order form sends itself as a request instead of leaving the page, then asks
 * the shop every second whether the provider has confirmed. The answer texts come
 * from the shop, the page keeps its own place and shows them below the form; there
 * is no dialog and no page preloader. A run that stays unconfirmed for two minutes
 * leaves the pending text standing, because the payment is exactly that: pending.
 */
import { postAction, getJson } from '../shell/request.js';

const POLL_INTERVAL = 1000;
const POLL_REQUEST_TIMEOUT = 5000;
const POLL_TOTAL_TIMEOUT = 120000;

document.addEventListener('alpine:init', () => {
    Alpine.data('delayedPayment', () => ({
        status: null,

        init() {
            this.addBeforeSubmit(() => this.confirm());
        },

        async confirm() {
            const form = this.$el.closest('form');
            const body = new FormData(form);
            body.set('renderPartial', 'ajaxOrder');

            const answer = await postAction(`/${URLSEGMENT}index.php?cl=order&fnc=execute`, body);
            this.status = answer;

            if (answer.resultCode === 'success') {
                return this.redirect(answer.redirectUrl);
            }
            if (answer.status !== 'waiting') {
                return this.abort();
            }

            return this.poll();
        },

        async poll() {
            const until = Date.now() + POLL_TOTAL_TIMEOUT;

            while (Date.now() < until) {
                await new Promise((resolve) => { setTimeout(resolve, POLL_INTERVAL); });

                const answer = await getJson(
                    `/${URLSEGMENT}index.php?cl=order&fnc=getDelayedPaymentStatus`,
                    { signal: AbortSignal.timeout(POLL_REQUEST_TIMEOUT) },
                );
                this.status = answer;

                if (answer.status === 'success') {
                    return this.redirect(`/${URLSEGMENT}index.php?cl=thankyou`);
                }
                if (answer.status !== 'waiting') {
                    return this.abort();
                }
            }

            // still waiting after two minutes: the pending text stays, the customer keeps the page
            return false;
        },

        abort() {
            return this.redirect(`/${URLSEGMENT}index.php?cl=payment&payerror=2&fnc=dd_abortPayment`);
        },
    }));
});
